import type { InteractiveElementPromptType } from '../PromptInteractiveElementType/types'
import type { PostAssignmentPromptType } from '../PromptPostAssignmentType/types'
import type { PostRoomStatePromptType } from '../PromptPostRoomStateType/types'
import type { RoomStatePromptType } from '../PromptRoomStateType/types'
import type { RubricType } from '../PromptRubricType/types'
import type { ToolPromptType } from '../PromptToolType/types'

export enum PromptType {
  interactiveElement = 'interactive_element_prompt',
  postRoomState = 'post_room_state_prompt',
  rubric = 'rubric_prompt',
  roomState = 'room_state_prompt',
  tool = 'tool_prompt',
  postAssignment = 'post_assignment_prompt',
}

export enum PromptVersionStatus {
  /** mutable, has not been used (installed) -> must be moved to published to be used */
  draft = 0,
  /** immutable and can be 'installed' (changed to current prompt version) */
  published = 1,
  /** previously published prompts that are no longer installed */
  archived = 2,
}

export type PromptPair =
  | { promptType: PromptType.rubric; subType: RubricType }
  | {
      promptType: PromptType.interactiveElement
      subType: InteractiveElementPromptType
    }
  | {
      promptType: PromptType.postRoomState
      subType: PostRoomStatePromptType
    }
  | {
      promptType: PromptType.roomState
      subType: RoomStatePromptType
    }
  | {
      promptType: PromptType.tool
      subType: ToolPromptType
    }
  | {
      promptType: PromptType.postAssignment
      subType: PostAssignmentPromptType
    }
